import React, { useEffect, useMemo, useState } from "react";
import Select from "react-select";
import { money } from "../../../utils/helpers";

// Valor monetario del ajuste: +cantidad al incrementar, -cantidad al reducir.
export const valorAjuste = (producto, item) => {
    const signo = producto.operacion === 'incrementar' ? 1 : (producto.operacion === 'reducir' ? -1 : 0);

    return signo * (+producto.cantidad || 0) * (+item?.costo_total || 0);
};

const HiddenRow = ({key, index, producto, setProducto, productos, items, remover, errors}) => {
    const item = items.find(item => item.id === producto.producto_id);
    const cantidad = item?.existencia ?? item?.cantidad;

    const existencia = cantidad ? +cantidad : '';
    const nuevaExistencia = existencia !== '' ? (existencia + ((producto.cantidad ?? 0) * (producto.operacion === 'reducir' ? -1 : 1))) : '';

    return <tr key={key} style={{display: 'none'}}><td colSpan={10}>
        <input type="hidden" name={`productos[${index}][producto_id]`} value={producto.producto_id} />
        <input type="hidden" name={`productos[${index}][existencia]`} value={existencia} />
        <input type="hidden" name={`productos[${index}][operacion]`} value={producto.operacion} />
        <input type="hidden" name={`productos[${index}][cantidad]`} value={producto.cantidad} />
        <input type="hidden" name={`productos[${index}][descripcion]`} value={producto.descripcion} />
        <input type="hidden" name={`productos[${index}][nuevaExistencia]`} value={nuevaExistencia} />
    </td></tr>;
};

const VisibleRow = ({key, index, producto, setProducto, productos, items, remover, errors}) => {
    const [existencia, setExistencia] = useState('');
    const [nuevaExistencia, setNuevaExistencia] = useState('');
    const options = items.filter(item => {
        if (producto.producto_id  === item.id) return true;

        return !productos.find(p => p.producto_id === item.id);
    }).map((item) => ({label: `${item.referencia} - ${item.nombre}`, value: item.id}));
    const valor = valorAjuste(producto, items.find(item => item.id === producto.producto_id));

    useEffect(() => {
        const item = items.find(item => item.id === producto.producto_id);
        const cantidad = item?.existencia ?? item?.cantidad;

        setExistencia(cantidad ? +cantidad : '');
        setNuevaExistencia(existencia !== '' ? (existencia + ((producto.cantidad ?? 0) * (producto.operacion === 'reducir' ? -1 : 1))) : '');
    }, [items, producto]);

    return <tr key={key}>
        <td className="text-center" style={{width: '50px'}}>{index + 1}</td>
        <td colSpan={2}>
            <Select 
                id={`productos[${index}][producto_id]`}
                name={`productos[${index}][producto_id]`}
				placeholder={"Buscar..."}
                options={options}
                value={
                    producto.producto_id && options.find(p => p.value === producto.producto_id)
                }
                onChange={(e) => setProducto(index, {...producto, producto_id: e.value})}
                styles={{
                    singleValue: (provided, state) => ({
                        ...provided,
                        width: "100%",
                        display: "flex",
                    }),
                    menu: (provided, state) => ({
                        ...provided,
                        width: "125%",
                    }),
                    option: (provided, state) => ({
                        ...provided,
                        backgroundColor: state.isSelected
                            ? "rgba(152, 204, 245,.3)"
                            : "white",
                        color: state.isSelected ? "#008aab" : "#666666",
                        fontWeight: state.isSelected ? "600" : "normal",
                    }),
                }}
                maxMenuHeight={200}
            />
        </td>
        <td style={{width: '100px'}}>
            <input name={`productos[${index}][existencia]`} className="form-control" value={existencia} readOnly />
        </td>
        <td style={{width: '125px'}}>
            <select
                name={`productos[${index}][operacion]`}
                className="form-control"
                value={producto.operacion}
                onChange={(e) => setProducto(index, {...producto, operacion: e.target.value, cantidad: e.target.value === 'igual' ? 0 : producto.cantidad})}
            >
                <option value="">Seleccionar...</option>
                <option value="incrementar">Incrementar</option>
                <option value="reducir">Reducir</option>
                <option value="igual">Igual</option>
            </select>
        </td>
        <td style={{width: '75px'}}>
            <input
                name={`productos[${index}][cantidad]`}
                className="form-control"
                value={producto.cantidad}
                onChange={(e) => setProducto(index, {...producto, cantidad: e.target.value})}
                type="number"
                min={0}
                step="0.01"
                readOnly={producto.operacion === 'igual'}
                disabled={!producto.operacion}
            />
        </td>
        <td style={{width: '250px'}}>
             <input
                name={`productos[${index}][descripcion]`}
                className="form-control"
                value={producto.descripcion}
                onChange={(e) => setProducto(index, {...producto, descripcion: e.target.value})}
                type="text"
                placeholder="Ingrese el motivo del ajuste"
            />
        </td>
        <td style={{width: '75px'}}>
            <input name={`productos[${index}][nuevaExistencia]`} className="form-control" value={nuevaExistencia} readOnly />
        </td>
        <td style={{width: '100px'}} className={`text-right${valor < 0 ? ' text-danger' : ''}`}>
            {money(valor)}
        </td>
        <td style={{width: '50px'}}>
            <button type="button" className="btn btn-danger" onClick={() => remover(index)}>
                <i className="zmdi zmdi-delete"></i>
            </button>
        </td>
    </tr>;
}

const ProductoRow = ({key, index, producto, setProducto, productos, items, remover, errors, show}) => {
    if (show) return <VisibleRow key={key} index={index} producto={producto} setProducto={setProducto} productos={productos} items={items} remover={remover} errors={errors} />;

    return <HiddenRow key={key} index={index} producto={producto} setProducto={setProducto} productos={productos} items={items} remover={remover} errors={errors} />;
}


export default ProductoRow;